import { request } from "./client";
import type { ActionUrlDomain, ActionUrlDomainCommand, Advertiser, AdvertiserCommand, AuditEvent } from "./types";

const base = "/admin/v1/advertisers";

export const advertisers = {
  list: () => request<Advertiser[]>(base),
  get: (id: string) => request<Advertiser>(`${base}/${id}`),
  create: (command: AdvertiserCommand) =>
    request<Advertiser>(base, { method: "POST", body: command, csrf: true }),
  update: (id: string, command: AdvertiserCommand) =>
    request<Advertiser>(`${base}/${id}`, { method: "PUT", body: command, csrf: true }),
  archive: (id: string) =>
    request<Advertiser>(`${base}/${id}`, { method: "DELETE", csrf: true }),
  audit: (id: string) => request<AuditEvent[]>(`${base}/${id}/audit`),
  actionUrlDomains: (id: string) => request<ActionUrlDomain[]>(`${base}/${id}/action-url-allowlist`),
  addActionUrlDomain: (id: string, command: ActionUrlDomainCommand) =>
    request<ActionUrlDomain>(`${base}/${id}/action-url-allowlist`, { method: "POST", body: command, csrf: true }),
};
